import * as XLSX from '@e965/xlsx';
import { saveAs } from 'file-saver';
import { message } from '../../components/antdMessageBridge';

/**
 * Exports data to an Excel file.
 * @param {Array<object>} dataSource - The data to export.
 * @param {Array<object>} columns - The column definitions from the antd table.
 * @param {string} filename - The desired name for the Excel file.
 */
export const exportToExcel = (dataSource, columns, filename) => {
    // Failsafe: Don't attempt to download if there's no data
    if (!dataSource || dataSource.length === 0) {
        message.warning("The grid is currently empty. There are no records to export");
        return;
    }

    // Extract headers from columns
    const headers = columns.map(col => col.title);
    const dataKeys = columns.map(col => col.dataIndex);

    // Map the data to only include keys present in the columns
    const formattedData = dataSource.map(item => {
        const row = {};
        columns.forEach((col, index) => {
            // Handles nested data structures by splitting `dataIndex`
            if (typeof col.dataIndex === 'string' && col.dataIndex.includes('.')) {
                const nestedKeys = col.dataIndex.split('.');
                let nestedValue = item;
                nestedKeys.forEach(key => {
                    if (nestedValue) {
                        nestedValue = nestedValue[key];
                    }
                });
                row[col.dataIndex] = nestedValue !== undefined ? nestedValue : '';
            } else {
                row[col.dataIndex] = item[col.dataIndex] !== undefined ? item[col.dataIndex] : '';
            }
        });
        return row;
    });

    // Convert the array of objects to a worksheet
    const worksheetData = [
        headers, // Header row with titles
        ...formattedData.map(row => dataKeys.map(key => row[key] || '')) 
    ];

    // Override the headers in the worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Create a new workbook and add the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Generate a blob and trigger the download
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(blob, `${filename}.xlsx`);
};
